import React from "react";

function Footer() {
  return (
    <>
      <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
        <p className="mb-0 text-gray-9">
          {new Date().getFullYear()} &copy; AxeSell. All Right Reserved
        </p>
        <p>
          Powered By{" "}
          <a href="#" className="text-primary">
            <img src={`${process.env.PUBLIC_URL}/img/logo.png`} style={{ width: '40px' }} />
          </a>
        </p>
      </div>
    </>
  );
}

export default Footer;
